import axios from 'axios'
import Service from '@/api/service'
import getFormDataFromJSON from '@/common/js/formdata'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

/*
    using '...Service('/url/:id/')' in object provides methods:
        fetch
        get
        delete
        put
        save
 */

export const SiteSettings = {
  update: payload => {
    return axios.put('/admin/core/settings/', payload)
  },
  get: payload => {
    return axios.get('/admin/core/settings/', payload)
  }
}

export const Attachment = {
  ...Service('/admin/attachments/:id/'),
  upload: payload => {
    return axios.post('/admin/attachments/', payload, {
      headers: { 'content-type': 'multipart/form-data' }
    })
  }
}

export const Article = {
  ...Service('/admin/articles/:id/')
}

export const ArticleTag = {
  ...Service('/admin/articles/tags/:id/')
}

export const ArticleCategory = {
  ...Service('/admin/articles/categories/:id/')
}

export const Page = {
  ...Service('/admin/pages/:id/')
}

export const PodcastCategory = {
  ...Service('/admin/podcasts/categories/:id/')
}
export const Podcast = {
  ...Service('/admin/podcasts/:id/')
}
export const PodcastsListingPage = {
  ...Service('/admin/podcasts/listing-page/')
}

export const Widget = {
  ...Service('/admin/widgets/:id/'),
  types(params) {
    return axios.get('/widgets/admin/types/', { params })
  },
  validate(payload) {
    return axios.post('/widgets/admin/validate/', payload)
  },
  available(params) {
    return axios.get('/widgets/admin/available/', { params })
  }
}

export const Menu = {
  ...Service('/admin/menu/:id/')
}

export const Link = {
  availableLinkOptions() {
    return axios.get('/admin/links/available-options/')
  },
  availableWidgets(params) {
    return axios.get('/admin/links/available-widgets/', { params })
  }
}

export const Auth = {
  login(payload) {
    return axios.post('/public/users/auth/login/', payload)
  }
}

export const Image = {
  ...Service('/images/admin/:id/'),
  save: (payload, onUploadProgress) => {
    const formData = getFormDataFromJSON(payload)
    return axios.post('/images/admin/', formData, {
      headers: {
        'content-type': 'multipart/form-data'
      },
      onUploadProgress
    })
  },
  update: (urlParams, payload) => {
    const formData = getFormDataFromJSON(payload)
    const defaultUpdate = Service('/images/admin/:id/')['update']
    return defaultUpdate(urlParams, formData, {
      'content-type': 'multipart/form-data'
    })
  }
}

export const Video = {
  ...Service('/admin/videos/:id/'),
  save: (payload, onUploadProgress) => {
    const formData = getFormDataFromJSON(payload)
    return axios.post('/admin/videos/', formData, {
      headers: {
        'content-type': 'multipart/form-data'
      },
      onUploadProgress
    })
  },
  update: (urlParams, payload) => {
    // Only include fields that should be updated
    // Exclude file fields that are URLs (not actual file uploads)
    const updatePayload = {
      title: payload.title,
      alt: payload.alt
    }
    // Only include file if it's an actual File object (new upload)
    if (payload.file instanceof File) {
      updatePayload.file = payload.file
    }
    const formData = getFormDataFromJSON(updatePayload)
    const defaultUpdate = Service('/admin/videos/:id/')['update']
    return defaultUpdate(urlParams, formData, {
      'content-type': 'multipart/form-data'
    })
  },
  reprocess: urlParams => {
    return axios.post(`/admin/videos/${urlParams.id}/reprocess/`)
  },
  status: urlParams => {
    return axios.get(`/admin/videos/${urlParams.id}/status/`)
  }
}

export const User = {
  ...Service('/admin/users/:id/')
}

export const Dashboard = {
  getContentCounters() {
    return axios.get('/admin/dashboard/content-counters/')
  },
  getRecentPages() {
    return axios.get('/admin/dashboard/recent-pages/')
  },
  getUser() {
    return axios.get('/admin/dashboard/user/')
  }
}

export const ToolCategory = {
  ...Service('/admin/tools/categories/:id/')
}

export const ToolSuggestion = {
  ...Service('/admin/tools/suggestions/:id/')
}

export const ContactForm = {
  ...Service('/admin/contact-form/:id/')
}
